import { MessageSquare } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FeedbackModal from './FeedbackModal';
import './feedback.css';

interface FeedbackButtonProps {
  placement?: 'floating' | 'header';
  sourcePage?: string;
}

export default function FeedbackButton({ placement = 'floating', sourcePage }: FeedbackButtonProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const page = sourcePage || (typeof window === 'undefined' ? '/' : window.location.pathname);
  return (
    <>
      <button
        type="button"
        className={`feedback-button feedback-button-${placement}`}
        aria-label={t('feedback.open', 'Send feedback')}
        title={t('feedback.open', 'Send feedback')}
        onClick={() => setOpen(true)}
      >
        <MessageSquare size={placement === 'header' ? 16 : 18} aria-hidden="true" />
        {placement === 'floating' && <span>{t('feedback.button', 'Feedback')}</span>}
      </button>
      <FeedbackModal open={open} onClose={() => setOpen(false)} sourcePage={page} />
    </>
  );
}
